// Selectors


import { RootState } from '../../store';

export const userPreferenceSelector = (state: RootState) => state.userPreferenceState

